var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderProductViewAidaiatiPublisher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2654 36.5305C18.6703 39.3561 12.7751 39.9456 12.7751 39.9456C12.7751 39.9456 11.7549 40.2857 10.7346 39.2654C9.71429 38.2451 10.0544 37.2249 10.0544 37.2249C10.0544 37.2249 10.6439 31.3297 13.4695 21.7346C13.8714 20.3698 14.9789 19.3341 16.3813 19.0942C18.2444 18.7756 21.1852 18.3726 25 18.1818L27.0587 17.5L32.5 22.9414L31.8182 25C31.6275 28.8148 31.2244 31.7556 30.9058 33.6187C30.6659 35.0211 29.6302 36.1286 28.2654 36.5305Z",
    fill: "#66BCB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18.1818C25.248 15.2061 26.2143 12.2003 26.7285 10.7853C26.9173 10.2656 27.4133 9.9369 27.9613 10.0102C29.5455 10.222 32.9364 11.022 35.9572 14.0428C38.9779 17.0636 39.7779 20.4545 39.9898 22.0387C40.0631 22.5867 39.7344 23.0827 39.2147 23.2716C37.7996 23.7857 34.7939 24.752 31.8182 25C31.8182 25 31.1634 22.9455 29.109 20.8911C27.0545 18.8366 25 18.1818 25 18.1818Z",
    fill: "#00726E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2477 38.6163C11.9194 36.7701 15.6709 32.6351 18.884 29.1529C18.8257 28.9309 18.7946 28.6979 18.7946 28.4577C18.7946 26.9515 20.0157 25.7305 21.5219 25.7305C23.0282 25.7305 24.2492 26.9515 24.2492 28.4577C24.2492 29.9639 23.0282 31.185 21.5219 31.185C21.2817 31.185 21.0487 31.1539 20.8268 31.0956C17.3404 34.3125 13.1998 38.0691 11.3568 39.7379C11.1554 39.6283 10.945 39.4758 10.7347 39.2654C10.5149 39.0457 10.3582 38.8259 10.2477 38.6163Z",
    fill: "#00726E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderProductViewAidaiatiPublisher);
export default __webpack_public_path__ + "static/media/HeaderProductViewAIDAIATIPublisher.adb9755e404c9ef14ce60ed895a4805e.svg";
export { ForwardRef as ReactComponent };